import React from 'react';
import './../styles/admin.css';
import { Outlet } from 'react-router-dom';
import NavbarTop from './admin/Navbartop';

const Admin = () => {
    return (
        <div className="app-admin app-container">
            <NavbarTop />
            <div className="main-content">
                <div className="page-container">
                    <Outlet />
                </div>
            </div>
        </div>
    );
};

export default Admin;